import { EventTypes } from 'redux-segment';

// Actions
const CREATE_DASHBOARD_LINK = 'zen/createDashboardLink/CREATE_DASHBOARD_LINK';
const CREATE_DASHBOARD_LINK_BEGAN = 'zen/createDashboardLink/CREATE_DASHBOARD_LINK_BEGAN';
const CREATE_DASHBOARD_LINK_SUCCEEDED = 'zen/createDashboardLink/CREATE_DASHBOARD_LINK_SUCCEEDED';
const CREATE_DASHBOARD_LINK_FAILED = 'zen/createDashboardLink/CREATE_DASHBOARD_LINK_FAILED';
const DATE_RANGE_CHANGED = 'zen/createDashboardLink/DATE_RANGE_CHANGED';
const IS_LINK_COPIED_CHANGED = 'zen/createDashboardLink/IS_LINK_COPIED_CHANGED';
const IS_MODAL_OPEN_CHANGED = 'zen/createDashboardLink/IS_MODAL_OPEN_CHANGED';
const SELECTED_EXPIRES_IN_CHANGED = 'zen/createDashboardLink/SELECTED_EXPIRES_IN_CHANGED';
const SET_INITIAL_STATE = 'zen/createDashboardLink/SET_INITIAL_STATE';

const initialState = {
  isCreatingDashboardLink: false,
  sharedToken: null,
  expiresIn: { value: 30, label: 'In 30 days' },
  selectedStartDate: '',
  selectedEndDate: '',
  timeStartWindow: false,
  isModalOpen: true,
  isLinkCopied: false
};

// Reducer
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_DASHBOARD_LINK_BEGAN:
      return {...state, sharedToken: null, isCreatingDashboardLink: true, postError: null};
    case CREATE_DASHBOARD_LINK_SUCCEEDED:
      return {...state, sharedToken: action.payload, isCreatingDashboardLink: false};
    case CREATE_DASHBOARD_LINK_FAILED:
      return {...state, sharedToken: null, isCreatingDashboardLink: false, postError: action.payload};
    case IS_MODAL_OPEN_CHANGED:
      return {...state, isModalOpen: false};
    case IS_LINK_COPIED_CHANGED:
      return {...state, isLinkCopied: true};
    case SELECTED_EXPIRES_IN_CHANGED:
      return {...state, expiresIn: action.payload};
    case SET_INITIAL_STATE:
      return {...initialState, postError: null};
    case DATE_RANGE_CHANGED:
      return {
        ...state,
        selectedStartDate: action.payload.startDate,
        selectedEndDate: action.payload.endDate,
        timeStartWindow: action.payload.timeStartWindow
      };
    default: return state;
  }
};

// Action Creators
const createDashboardLink = ( // eslint-disable-line max-params
  campaignId, createdBy, dashboardName, dashboardId
) => {
  return { type: CREATE_DASHBOARD_LINK, campaignId, createdBy, dashboardName, dashboardId };
};

const createDashboardLinkBegan = () => {
  return { type: CREATE_DASHBOARD_LINK_BEGAN };
};

const createDashboardLinkSucceeded = (payload, analytics) => {
  return {
    type: CREATE_DASHBOARD_LINK_SUCCEEDED,
    payload,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Dashboard: Create Dashboard Link',
          properties: analytics,
        },
      },
    }
  };
};

const createDashboardLinkFailed = (payload) => {
  return { type: CREATE_DASHBOARD_LINK_FAILED, payload };
};

const setExpiresIn = (payload) => {
  return { type: SELECTED_EXPIRES_IN_CHANGED, payload };
};

const closeModal = () => {
  return { type: IS_MODAL_OPEN_CHANGED };
};

const setLinkCopied = () => {
  return { type: IS_LINK_COPIED_CHANGED };
};

const setDateRange = (payload) => {
  return { type: DATE_RANGE_CHANGED, payload };
};

const setInitialState = () => {
  return { type: SET_INITIAL_STATE };
};

export default reducer;
export {
  // Actions
  CREATE_DASHBOARD_LINK,
  CREATE_DASHBOARD_LINK_BEGAN,
  CREATE_DASHBOARD_LINK_SUCCEEDED,
  CREATE_DASHBOARD_LINK_FAILED,
  DATE_RANGE_CHANGED,
  IS_MODAL_OPEN_CHANGED,
  IS_LINK_COPIED_CHANGED,
  SELECTED_EXPIRES_IN_CHANGED,
  SET_INITIAL_STATE,

  // Action Creators
  setExpiresIn,
  setDateRange,
  setInitialState,
  closeModal,
  setLinkCopied,
  createDashboardLink,
  createDashboardLinkBegan,
  createDashboardLinkSucceeded,
  createDashboardLinkFailed,
};
